import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ContractSwitchView } from "@mfa-aff/shared";
import { contractSwitchConfirmMock, contractSwitchMock } from "../mocks/contract";
import { get, send } from "./client";
import { homeKey } from "./home";
import { levelsKey } from "./levels";
import { meKey, notificationsKey } from "./me";
import { partnerPaths } from "./paths";

export const contractSwitchKey = ["partner", "contract-switch"] as const;

/** `GET /contract-switch`: a contract partner's rates next to the level their sales qualify for. Asked only for contract partners. */
export const useContractSwitch = (enabled: boolean) =>
    useQuery({ queryKey: contractSwitchKey, queryFn: () => get<ContractSwitchView>(partnerPaths.contractSwitch, contractSwitchMock), enabled });

/** `POST /contract-switch {agree: true}`: leave the contract for the level ladder. Errors are shown in the dialog. */
export const useContractSwitchConfirm = () => {
    const qc = useQueryClient();
    return useMutation({
        meta: { silent: true },
        mutationFn: () => send<ContractSwitchView>("POST", partnerPaths.contractSwitch, { agree: true }, contractSwitchConfirmMock),
        onSuccess: (data) => {
            qc.setQueryData(contractSwitchKey, data);
            // The levels page and the home card show the normal ladder from now on.
            return Promise.all([levelsKey, homeKey, meKey, notificationsKey].map((queryKey) => qc.invalidateQueries({ queryKey })));
        },
    });
};
